/**
 * TrueToForm bodyscan widget — shared trigger for any [data-cpi-ttf-trigger].
 *
 * The third-party widget mounts into #TTF_WIDGET_CONTAINER and opens its scanner
 * overlay when `ttf:open-widget` is dispatched on window. The script is lazy-loaded
 * on first click.
 */

let ttfReady = false;
let ttfLoading = false;
let ttfOpenPending = false;
/** @type {number | null} */
let ttfReadyFallback = null;

function dispatchTrueToFormOpen() {
  if (ttfReadyFallback) {
    window.clearTimeout(ttfReadyFallback);
    ttfReadyFallback = null;
  }
  requestAnimationFrame(() => {
    window.dispatchEvent(new CustomEvent('ttf:open-widget'));
  });
}

function loadTrueToForm() {
  if (ttfLoading) return;
  ttfLoading = true;

  const onReady = () => {
    ttfReady = true;
    if (ttfOpenPending) {
      ttfOpenPending = false;
      dispatchTrueToFormOpen();
    }
  };

  window.addEventListener('ttf:button:ready', onReady, { once: true });
  ttfReadyFallback = window.setTimeout(onReady, 4000);

  const container = document.getElementById('TTF_WIDGET_CONTAINER');
  if (!container) {
    ttfLoading = false;
    ttfOpenPending = false;
    return;
  }

  const script = document.createElement('script');
  script.type = 'module';
  script.src = 'https://ttf-widget.pages.dev/assets/integrations/custom.js';
  script.addEventListener('error', () => {
    ttfLoading = false;
    ttfOpenPending = false;
  });
  document.body.appendChild(script);
}

export function openTrueToForm() {
  if (ttfReady) {
    dispatchTrueToFormOpen();
    return;
  }
  ttfOpenPending = true;
  loadTrueToForm();
}

/** @param {Event} event */
function onTrueToFormScanReady(event) {
  const detail = event instanceof CustomEvent ? event.detail : null;
  const scanId = detail?.scanId;
  if (!scanId) return;

  const host = document.querySelector('custom-product-information');
  if (host instanceof HTMLElement) {
    host.dataset.ttfScanId = String(scanId);
    host.dispatchEvent(new CustomEvent('cpi:bodyscan-ready', { detail, bubbles: true }));
  }
}

document.addEventListener('click', (event) => {
  const target = event.target instanceof Element ? event.target : null;
  if (!target?.closest('[data-cpi-ttf-trigger]')) return;
  event.preventDefault();
  openTrueToForm();
});

window.addEventListener('ttf:scan-ready', onTrueToFormScanReady);
